import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
} from './constants'

export const forgotPasswordRequestAction = payload => ({
  type: FORGOT_PASSWORD_REQUEST,
  payload,
})

export const forgotPasswordSuccessAction = payload => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload,
})

export const forgotPasswordFailureAction = payload => ({
  type: FORGOT_PASSWORD_FAILURE,
  payload,
})
